<template>
  <v-container>
    <static-page-content uri="/static/pages/demos-bc-artist" />
    <bc-artist :artist="$config.methods.album.artist" />
    <static-page-content uri="/static/pages/demos-bc-search" :class="['mt-3']" />
    <bc-search :class="['mb-3']" />
  </v-container>
</template>
<script>
export default {
  name: 'DemosPage'
}
</script>



// WEBPACK FOOTER //
// src/pages/demos.vue